var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-manage"},[_c('keep-alive',{attrs:{"exclude":"OrderManageDetail"}},[_c('router-view',{staticClass:"order-manage-container"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }